<template>
    <div>
        <app-table :id="tableId" :options="options" @action="getListAction" />
    </div>
</template>

<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import * as actions from "../../../../../apiUrl";
    import { TabEvaluationTeamHelpers } from "../../helpers/TabEvaluationTeamHelpers";

    export default {
        extends: CoreLibrary,
        name: "TabResponseFindings",
        mixins: [TabEvaluationTeamHelpers],
        data() {
            return {
                deleteLoader: false,
                isAddEditModalActive: false,
                deleteConfirmationModalActive: false,
                selectedUrl: "",
                accreditationId: "",
                tableId: "response-findings-list",
                rowData: {},
                options: {
                    url: `${actions.ACCREDITATION_PROCESS}/documentaryEvaluationInfo/403`,
                    name: this.$t("demo_crud"),
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t("Tratamiento de Hallazgos"),
                            icon: "edit",
                            type: "none",
                            component: "response-findings-modal",
                            modalId: "resp-findings-modal",
                        },
                    ],
                    showFilter: false,
                    showSearch: false,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: "desc",
                    actionType: "default"
                },
            };
        },
        created() {
            this.$hub.$on("reload-table", () => {
                this.$hub.$emit("reload-" + this.tableId);
            });
            this.options.columns = [...this.tableColumns, this.actionObj];
        },
        methods: {
            getListAction(rowData, actionObj, active) {
                this.rowData = rowData;
                window.location = `${actions.ACCREDITATION_PROCESS}/documentaryEvaluation/edit/${this.rowData.id}`;
            },
            data() {},
        },
    };
</script>
